// extracted by mini-css-extract-plugin
export default {"colorbar":"Layout_colorbar__YUJ6m","colorbarBottom":"Layout_colorbarBottom__nul8i","mainContent":"Layout_mainContent__6OoEY"};